<template>
    <activiteiten-grid />
</template>

<script>
import ActiviteitenGrid from './components/ActiviteitenGrid.vue'

export default {
    components: { ActiviteitenGrid }
}
</script>
